import clsx from "clsx";
import { type ComponentProps, useCallback } from "react";

import { Button } from "@shared/ui/button";
import { Image } from "@shared/ui/image";
import { MediaPicture } from "@shared/ui/picture";
import { Body } from "@shared/ui/typography";

import type { HomeHeroType } from "@/_pages/home/model";

import s from "./home-hero-pagination.module.scss";

export type PaginationCardsProps = ComponentProps<"div"> & {
  card: HomeHeroType;
  isActive: boolean;
  index: number;
  onPaginationClick: (index: number) => void;
};

export const PaginationCards = (props: PaginationCardsProps) => {
  const { card, isActive, index, onPaginationClick } = props;

  const handleClick = useCallback(() => {
    onPaginationClick(index);
  }, [index, onPaginationClick]);

  const objSource = {
    alt: card.backgroundImage?.alternativeText ?? "slide card",
    src: {
      desktop: card?.backgroundImage?.url,
      tablet: card.backgroundImageMobile?.url ?? card?.backgroundImage?.url,
      mobile: card.backgroundImageMobile?.url ?? card?.backgroundImage?.url,
    },
  };

  return (
    <Button
      onClick={handleClick}
      className={clsx(s.root, { [s.activeCard]: isActive })}
    >
      {card?.backgroundImage?.url && (
        <MediaPicture objSource={objSource} className={s.cardImage} />
      )}
      <div className={s.cardContent}>
        {card.title.text && (
          <Body size="uppercase" weight="semiBold">
            {card.title.text}
          </Body>
        )}
        {card.date && (
          <Body size="uppercase-small" weight="semiBold">
            {card.date}
          </Body>
        )}
      </div>
      <div className={s.progessLine} />
    </Button>
  );
};

PaginationCards.displayName = "PaginationCards";
